<script setup lang="ts">
import Checkbox from '@/assets/svgs/check_box.svg'
import CheckboxFill from '@/assets/svgs/check_box_fill.svg'
import BaseLargeButton from '@/components/base/BaseLargeButton.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import { useAuthStore } from '@/stores/auth'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

const signupRequest = window.history.state?.signupRequest
const authStore = useAuthStore()
const router = useRouter()
const isMobile = useIsMobile()

const ageCheckbox = ref(false)
const serviceCheckbox = ref(false)
const personalInfoCheckbox = ref(false)
const adsCheckbox = ref(false)

const disabled = computed(() => {
  return !(ageCheckbox.value && serviceCheckbox.value && personalInfoCheckbox.value)
})

const handleSignup = async () => {
  console.log('signup')
  console.log(signupRequest)

  await authStore.signup({
    socialKey: signupRequest.socialKey,
    socialType: signupRequest.socialType,
    subscribedAds: adsCheckbox.value,
  })

  router.push('/dashboard')
}
</script>

<template>
  <div class="signup-view">
    <div class="signup-view-container">
      <div class="signup-view-title title-lg" :class="{ 'title-md': isMobile }">회원가입</div>
      <div class="signup-view-description body-md gray-600" :class="{ 'body-sm': isMobile }">
        프렌드 아카데미 약관을 확인해 주세요.
      </div>
      <div class="signup-view-form">
        <div class="signup-view-form-item">
          <div class="signup-view-form-item-input cursor-pointer">
            <img
              :src="ageCheckbox ? CheckboxFill : Checkbox"
              alt="check"
              @click="ageCheckbox = !ageCheckbox"
            />
          </div>
          <div class="signup-view-form-item-label body-md">[필수] 만 14세 이상입니다.</div>
        </div>
        <div class="signup-view-form-item">
          <div class="signup-view-form-item-input cursor-pointer">
            <img
              :src="serviceCheckbox ? CheckboxFill : Checkbox"
              alt="check"
              @click="serviceCheckbox = !serviceCheckbox"
            />
          </div>
          <div class="signup-view-form-item-label body-md">
            [필수] 서비스 이용약관에 동의합니다.
          </div>
        </div>
        <div class="signup-view-form-item">
          <div class="signup-view-form-item-input cursor-pointer">
            <img
              :src="personalInfoCheckbox ? CheckboxFill : Checkbox"
              alt="check"
              @click="personalInfoCheckbox = !personalInfoCheckbox"
            />
          </div>
          <div class="signup-view-form-item-label body-md">
            [필수] 개인정보 수집 및 이용에 동의합니다.
          </div>
        </div>
        <div class="signup-view-form-item">
          <div class="signup-view-form-item-input cursor-pointer">
            <img
              :src="adsCheckbox ? CheckboxFill : Checkbox"
              alt="check"
              @click="adsCheckbox = !adsCheckbox"
            />
          </div>
          <div class="signup-view-form-item-label body-md">
            E-mail 및 SMS 광고성 정보에 수신동의합니다.
          </div>
        </div>
        <div class="signup-view-form-button">
          <BaseLargeButton text="확인" type="main" :disabled="disabled" @click="handleSignup" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.signup-view {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
  background-color: var(--white);
  flex-direction: column;
  padding: 20px;
}

.signup-view-container {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.signup-view-title {
  margin-bottom: 12px;
}

.signup-view-description {
  margin-bottom: 20px;
}

.signup-view-form {
  padding: 32px 40px;
  border-radius: 8px;
  border: 1px solid var(--gray-200);
}

.signup-view-form-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.signup-view-form-item-input {
  width: 24px;
  height: 24px;
}

.signup-view-form-button {
  margin-top: 40px;
}
</style>
